import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";
import { ADMIN } from "../../Usuario/Perfil";
import UsuarioPerfilTable from "../../Usuario/UsuarioPerfilTable";
import AlunoResponsavelAtivoTable from "../../AlunoResponsavel/AlunoResponsavelAtivoTable";
import UsuarioInstituicaoTable from "../../UsuarioInstituicao/UsuarioInstituicaoTable";
import CredentialK8PayContainer from "../../CredentialK8Pay/CredentialK8PayContainer";
import UsuarioCartaoCreditoContainer from "../../UsuarioCartaoCredito/UsuarioCartaoCreditoContainer";
import AnoLetivoCard from "./AnoLetivoCard";
import MeusDadosCard from "./MeusDadosCard";
import PlataformaCard from "./PlataformaCard";
import SystemColors from "./SystemColors";

// Colunas em "masonry": blocos que não se aplicam ao usuário (retornam null)
// não deixam buracos no layout.
const columnsSx = {
  columnCount: { xs: 1, md: 2 },
  columnGap: 24,
  "& > *": { breakInside: "avoid", mb: 3 },
};

const SectionTitle = ({ children }) => (
  <Typography variant="overline" color="text.secondary" component="h2" display="block" mb={1}>
    {children}
  </Typography>
);

const ConfiguracaoInstituicaoContainer = () => {
  const usuario = useSelector((state) => state.usuario);

  return (
    <Box>
      <SectionTitle>Minha Conta</SectionTitle>
      <Box sx={columnsSx}>
        <MeusDadosCard />
        <AnoLetivoCard />
        <UsuarioPerfilTable />
        <UsuarioInstituicaoTable />
        <AlunoResponsavelAtivoTable />
        <UsuarioCartaoCreditoContainer />
      </Box>

      {usuario?.perfil === ADMIN && (
        <>
          <SectionTitle>Administração da Plataforma</SectionTitle>
          <Box sx={columnsSx}>
            <PlataformaCard />
            <SystemColors />
            <CredentialK8PayContainer />
          </Box>
        </>
      )}
    </Box>
  );
};

export default ConfiguracaoInstituicaoContainer;
